<template>

    <div class="galaxy::common-canvas-editor-Gallery tw-h-full tw-w-full tw-flex tw-flex-col tw-relative">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.26 68.42"
             class="tw-absolute tw-w-40 tw-pointer-events-none tw--mr-4 arrow"
             v-if="canvasVersion.canvas_blocks.length == 0">
            <path d="M6.19,9.4Q4.9,7.87,3.62,6.3L5.18,5Q6.44,6.6,7.72,8.11Z"></path>
            <path
                d="M139.15,68.42q-2,0-4,0l0-2q4.09.08,8.16,0l0,2Q141.29,68.42,139.15,68.42ZM128,68.13c-2.75-.15-5.52-.35-8.22-.61l.19-2c2.68.25,5.42.45,8.14.6Zm22.65,0-.11-2c2.7-.14,5.44-.33,8.15-.58l.18,2C156.12,67.78,153.36,68,150.63,68.12ZM166,66.79l-.24-2c2.69-.32,5.41-.7,8.09-1.11l.31,2C171.48,66.09,168.73,66.47,166,66.79Zm-53.43-.08c-2.73-.36-5.47-.78-8.15-1.25l.35-2c2.64.47,5.36.88,8.06,1.24Zm68.69-2.25-.37-2c2.66-.49,5.35-1,8-1.62l.43,2C186.68,63.41,184,64,181.28,64.46Zm-83.92-.4c-2.68-.58-5.38-1.24-8-1.94l.52-1.93c2.6.69,5.27,1.34,7.93,1.92Zm-15-3.94c-2.63-.82-5.26-1.71-7.81-2.65l.69-1.88c2.53.93,5.12,1.81,7.72,2.62ZM67.87,54.84c-2.54-1.06-5.07-2.19-7.53-3.37l.86-1.8C63.63,50.83,66.13,52,68.64,53Zm-14-6.62c-2.41-1.29-4.82-2.66-7.17-4.07l1-1.71c2.32,1.4,4.71,2.75,7.08,4ZM40.62,40.27c-2.28-1.52-4.55-3.12-6.74-4.75l1.19-1.6c2.17,1.62,4.41,3.19,6.66,4.69ZM28.19,31.08c-2.11-1.73-4.22-3.54-6.25-5.38l1.34-1.48c2,1.82,4.09,3.61,6.18,5.31ZM16.69,20.75c-1.94-1.91-3.86-3.91-5.73-5.93l1.47-1.35c1.84,2,3.74,4,5.66,5.86Z"></path>
            <path d="M196.38,61.16l-.49-1.94q1.94-.49,3.85-1l.52,1.93Q198.33,60.67,196.38,61.16Z"></path>
            <polygon points="1.39 9.88 0 0 9.24 3.73 1.39 9.88"></polygon>
        </svg>

        <div class="tw-h-full tw-overflow-auto tw-pt-4 tw-pl-5">

            <div class="tw-flex tw-items-center">

                <div>
                    <h4 class="tw-my-0">Blok toevoegen</h4>
                    <h6 class="tw-mt-1 tw-mb-0">Kies een blok uit één van de categorieën en sleep deze links op de
                        pagina om toe te voegen.</h6>
                </div>

                <div class="btn-group tw-ml-auto tw-mr-5 categories">

                    <button
                        v-for="category in activeGalleryData"
                        :key="category.id"
                        class="btn tw-mr-1 tw-outline-none tw-cursor-pointer"
                        :class="activeCategory == category ? 'btn-info tw-text-white' : 'tw-bg-gray-200'"
                        type="button"
                        @click="activeCategory = category">
                        {{ category.label }}
                    </button>

                </div>

            </div>

            <div class="mt-5 tw-h-full tw-pr-5">

                <div class="blocks tw-grid tw-grid-cols-3 tw-gap-6 tw-pb-10">

                    <div class="tw-flex hover:tw-opacity-50 tw-transition-all"
                         v-for="block in activeCategory.blocks">

                        <button
                            class="tw-col-span-1 tw-flex tw-flex-col tw-text-center tw-bg-white tw-rounded-lg tw-shadow tw-divide-y tw-divide-gray-200 tw-h-80 tw-w-full"
                            draggable="true"
                            :title="block.id"
                            @dragstart="onDragStart(block)"
                            @dragend="onDragEnd"
                            @click="addBlock(block)">

                            <div class="tw-flex-1 tw-flex tw-flex-col tw-px-2 tw-py-5 tw-mx-auto tw-w-full">

                                <div class="tw-h-32"
                                     draggable="false"
                                     v-if="block.iconOrGalleryImage ? block.iconOrGalleryImage.original : false"
                                     v-html="block.iconOrGalleryImage.original"
                                     :title="activeCategory.id + '.' + block.id">
                                </div>

                                <div v-else-if="block.iconOrGalleryImage"
                                     class="tw-h-32 tw-flex tw-items-center">
                                    <img :src="block.iconOrGalleryImage"
                                         draggable="false"
                                         :title="block.id"/>
                                </div>

                                <div v-else
                                     class="tw-h-32 tw-flex tw-items-center">
                                    <img src="/vendor/galaxy/img/common/canvas/editor/images/question-mark.svg"
                                         draggable="false"
                                         :title="activeCategory.id + '.' + block.id"
                                         class="tw-h-full tw-mx-auto"/>
                                </div>

                                <h3 class="tw-mt-6 tw-text-gray-900 tw-text-base tw-font-medium tw-truncate tw-w-full tw-mx-auto"
                                    :title="block.config.name">{{ block.config.name }}</h3>
                                <dl class="tw-mt-1 tw-flex-grow tw-flex tw-flex-col tw-justify-between">
                                    <dt class="tw-sr-only">Description</dt>
                                    <dd class="tw-text-gray-500 tw-text-sm description"
                                        :title="block.config.description">{{ block.config.description }}
                                    </dd>
                                    <dt class="tw-sr-only">Role</dt>
                                    <dd class="tw-mt-3">
                                        <span v-for="(color, text) in block.config.tags"
                                              :class="color"
                                              class="tw-px-2 tw-mx-1 tw-py-1 tw-text-xs tw-font-medium tw-text-black tw-rounded-full">
                                            {{ text }}
                                        </span>
                                    </dd>
                                </dl>
                            </div>

                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

export default {

    props: {
        canvasVersion: Object,
        canvasBlocksGalleryData: Array,
    },

    data() {
        return {
            activeCategory: this.canvasBlocksGalleryData[0],
        };
    },

    methods: {

        onDragStart(block) {
            this.$emit('onDraggingBlockId', block.id);
        },

        onDragEnd() {
            this.$emit('onDraggingBlockId', null);
        },

        addBlock(block) {
            this.$parent.$refs['canvasComponent'].$refs['iframe'].iframeApp.pageComponent.addBlock(block.id);
        },

    },

    computed: {

        activeGalleryData() {
            // Filter out utils.
            return _.filter(this.canvasBlocksGalleryData, category => category.id != 'utils');
        },

    },

}

</script>

<style lang="scss">
.galaxy\:\:common-canvas-editor-Gallery {
    .blocks {
        button {
            svg {
                @apply tw-h-full tw-w-auto tw-mx-auto;
            }
        }
    }
}
</style>

<style lang="scss" scoped>

.galaxy\:\:common-canvas-editor-Gallery {
    border-left: 1px solid #e2e8f0;

    .arrow {
        fill:  #909090;
        right: calc(100% - 25px);
        top:   185px;
    }

    h6 {
        color:       #90a4ae;
        font-weight: 300;
    }

    .categories button {
        box-shadow: none !important;;

        &:not(.btn-info) {
            background: #eee;
        }
    }

    .blocks {

        button {
            transition: box-shadow .3s;

            &:active {
                border: 1px solid #edf2f7 !important;
            }

            &:hover {
                @apply tw-shadow;
            }

            img {
                max-width:   100%;
                user-select: none;
                max-height: 100%;
                margin: auto;
            }

            .description {
                display:            -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow:           hidden;
            }
        }
    }

}

</style>
